import { MARQUEE_ITEMS } from "@/lib/site";

const Asterisk = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" className="shrink-0 text-copper" aria-hidden="true">
    <path d="M8 0v16M0 8h16M2.3 2.3l11.4 11.4M13.7 2.3L2.3 13.7" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative py-6 border-y border-line bg-cream overflow-hidden" aria-hidden="true">
      <div className="marquee-track flex items-center gap-8 w-max">
        {[...row, ...row].map((item, i) => (
          <span key={i} className="flex items-center gap-8">
            <span className="font-display font-semibold text-lg sm:text-xl tracking-tight text-ink/70 whitespace-nowrap uppercase">
              {item}
            </span>
            <Asterisk />
          </span>
        ))}
      </div>
    </div>
  );
};
